export default "__VITE_ASSET__Dz3_qlvG__"